// import React, { useState, useEffect } from 'react';
// import { AddAddressApi, UpdateAddressApi } from '../../ApiCalls/Address';

// const AddAddress = ({ closeModal, onAddressAdded, addressToEdit }) => {
//   const initialFormData = {
//     name: '',
//     mobile: '',
//     state: '',
//     housename: '',
//     city: '',
//     landmark: '',
//     pincode: ''
//   };

//   const [formData, setFormData] = useState(initialFormData);
// // console.log('addresstoedit',addressToEdit);

//   useEffect(() => {
//     if (addressToEdit) {
//       setFormData({
//         name: addressToEdit.name,
//         mobile: addressToEdit.mobile,
//         state: addressToEdit.state,
//         housename: addressToEdit.housename,
//         city: addressToEdit.city,
//         landmark: addressToEdit.landmark || '',
//         pincode: addressToEdit.pincode
//       });
//     }
//   }, [addressToEdit]);

//   const token = localStorage.getItem('token');

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       let res;
//       if (addressToEdit) {
//         // Update address
//         const id = addressToEdit.id
//         // console.log('idddddd',id);

//         res = await UpdateAddressApi(formData,id );
//         console.log('Address updated:', res);
//       } else {
//         // Add new address
//         res = await AddAddressApi(formData);
//         // console.log('Address added:', res);
//       }
//       setFormData(initialFormData); // Reset form
//       onAddressAdded(); // Notify parent component
//       closeModal(); // Close the modal
//     } catch (error) {
//       console.log(error);
//     }
//     // console.log('Form Data Submitted:', formData);
//   };

//   return (
//     <div className="h-auto w-full p-6">
//       <h2 className="text-xl font-semibold text-center text-brand-primary mb-4">
//         {addressToEdit ? 'Edit Address' : 'Add New Address'}
//       </h2>
//       <form onSubmit={handleSubmit} className="space-y-4">
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           <div className="flex flex-col">
//             <label htmlFor="name" className="text-sm font-medium">Name</label>
//             <input
//               type="text"
//               name="name"
//               id="name"
//               value={formData.name}
//               onChange={handleChange}
//               required
//                className="p-2 focus:outline-none "
//             />
//           </div>
//           <div className="flex flex-col">
//             <label htmlFor="mobile" className="text-sm font-medium">Mobile</label>
//             <input
//               type="tel"
//               name="mobile"
//               id="mobile"
//               value={formData.mobile}
//               onChange={handleChange}
//               required
//                className="p-2 focus:outline-none "
//             />
//           </div>
//           <div className="flex flex-col md:col-span-2">
//             <label htmlFor="housename" className="text-sm font-medium">House Name</label>
//             <input
//               type="text"
//               name="housename"
//               id="housename"
//               value={formData.housename}
//               onChange={handleChange}
//               required
//                className="p-2 focus:outline-none "
//             />
//           </div>
//           <div className="flex flex-col">
//             <label htmlFor="city" className="text-sm font-medium">City</label>
//             <input
//               type="text"
//               name="city"
//               id="city"
//               value={formData.city}
//               onChange={handleChange}
//               required
//                className="p-2 focus:outline-none "
//             />
//           </div>
//           <div className="flex flex-col">
//             <label htmlFor="landmark" className="text-sm font-medium">Landmark</label>
//             <input
//               type="text"
//               name="landmark"
//               id="landmark"
//               value={formData.landmark}
//               onChange={handleChange}
//                className="p-2 focus:outline-none "
//             />
//           </div>
//           <div className="flex flex-col">
//             <label htmlFor="pincode" className="text-sm font-medium">Pincode</label>
//             <input
//               type="text"
//               name="pincode"
//               id="pincode"
//               value={formData.pincode}
//               onChange={handleChange}
//               required
//                className="p-2 focus:outline-none "
//             />
//           </div>
//           <div className="flex flex-col">
//             <label htmlFor="state" className="text-sm font-medium">State</label>
//             <input
//               type="text"
//               name="state"
//               id="state"
//               value={formData.state}
//               onChange={handleChange}
//               required
//                className="p-2 focus:outline-none "
//             />
//           </div>
//         </div>
//         <button
//           type="submit"
//           className="w-full py-3 text-white bg-brand-primary rounded hover:bg-brand-primary-dark transition duration-200"
//         >
//           {addressToEdit ? 'Update Address' : 'Add Address'}
//         </button>
//       </form>

//     </div>
//   );
// };

// export default AddAddress;

import React, { useState, useEffect } from "react";
import { AddAddressApi, UpdateAddressApi } from "../../ApiCalls/Address";

const AddAddress = ({
  closeModal,
  onAddressAdded,
  addressToEdit,
  headHidden,
}) => {
  const initialFormData = {
    name: "",
    mobile: "",
    state: "",
    housename: "",
    city: "",
    landmark: "",
    pincode: "",
    country:"",
  };

  const [formData, setFormData] = useState(initialFormData);
  // console.log('addresstoedit',addressToEdit);

  useEffect(() => {
    if (addressToEdit) {
      setFormData({
        name: addressToEdit.name,
        mobile: addressToEdit.mobile,
        state: addressToEdit.state,
        housename: addressToEdit.housename,
        city: addressToEdit.city,
        landmark: addressToEdit.landmark || "",
        pincode: addressToEdit.pincode,
        country: addressToEdit.country || "",
      });
    }
  }, [addressToEdit]);

  const token = localStorage.getItem("token");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let res;
      if (addressToEdit) {
        // Update address
        const id = addressToEdit.id;
        // console.log('idddddd',id);

        res = await UpdateAddressApi(formData, id);
        console.log("Address updated:", res);
      } else {
        // Add new address
        res = await AddAddressApi(formData);
        // console.log('Address added:', res);
      }
      setFormData(initialFormData); // Reset form
      onAddressAdded(); // Notify parent component
      closeModal(); // Close the modal
    } catch (error) {
      console.log(error);
    }
    // console.log('Form Data Submitted:', formData);
  };

  return (
    <div className="h-auto w-full p-6">
      {headHidden && (
        <h2 className="mb-4 text-center text-xl font-semibold text-brand-primary">
          {addressToEdit ? "Edit Address" : "Add New Address"}
        </h2>
      )}
      <form onSubmit={handleSubmit} className="">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="flex flex-col rounded-lg border border-gray-300 p-2">
            <label htmlFor="name" className="text-sm font-medium">
              Name
            </label>
            <input
              type="text"
              name="name"
              id="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="p-2 focus:outline-none"
            />
          </div>
          <div className="flex flex-col rounded-lg border border-gray-300 p-2">
            <label htmlFor="mobile" className="text-sm font-medium">
              Mobile
            </label>
            <input
              type="tel"
              name="mobile"
              id="mobile"
              value={formData.mobile}
              onChange={handleChange}
              required
              className="p-2 focus:outline-none"
            />
          </div>
          <div className="flex flex-col rounded-lg border border-gray-300 p-2 md:col-span-2">
            <label htmlFor="housename" className="text-sm font-medium">
              House Name
            </label>
            <textarea
              type="text"
              name="housename"
              id="housename"
              value={formData.housename}
              onChange={handleChange}
              required
              className="p-2 focus:outline-none"
            />
          </div>
          <div className="flex flex-col rounded-lg border border-gray-300 p-2">
            <label htmlFor="city" className="text-sm font-medium">
              City
            </label>
            <input
              type="text"
              name="city"
              id="city"
              value={formData.city}
              onChange={handleChange}
              required
              className="p-2 focus:outline-none"
            />
          </div>
          <div className="flex flex-col rounded-lg border border-gray-300 p-2">
            <label htmlFor="landmark" className="text-sm font-medium">
              Landmark
            </label>
            <input
              type="text"
              name="landmark"
              id="landmark"
              value={formData.landmark}
              onChange={handleChange}
              className="p-2 focus:outline-none"
            />
          </div>
          <div className="flex flex-col rounded-lg border border-gray-300 p-2">
            <label htmlFor="pincode" className="text-sm font-medium">
              Pincode
            </label>
            <input
              type="text"
              name="pincode"
              id="pincode"
              value={formData.pincode}
              onChange={handleChange}
              required
              className="p-2 focus:outline-none"
            />
          </div>
          <div className="flex flex-col rounded-lg border border-gray-300 p-2">
            <label htmlFor="state" className="text-sm font-medium">
              State
            </label>
            <input
              type="text"
              name="state"
              id="state"
              value={formData.state}
              onChange={handleChange}
              required
              className="p-2 focus:outline-none"
            />
          </div>
          <div className="flex flex-col rounded-lg border border-gray-300 p-2">
            <label htmlFor="state" className="text-sm font-medium">
              Country
            </label>
            <input
              type="text"
              name="country"
              id="country"
              value={formData.country}
              onChange={handleChange}
              required
              className="p-2 focus:outline-none"
            />
          </div>
        </div>
        <button
          type="submit"
          className="hover:bg-brand-primary-dark mt-10 w-full rounded bg-brand-primary py-3 text-white transition duration-200"
        >
          {addressToEdit ? "Update Address" : "Add Address"}
        </button>
      </form>
    </div>
  );
};

export default AddAddress;
